exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?modules&minimize&importLoaders=1!../../../node_modules/postcss-loader/index.js!../../css/variables.css"), "");

// module
exports.push([module.id, "._1zd9L-0DCb44zrq8fNFxmy{width:100vw;height:100vh;max-width:100%;display:flex;align-items:center;justify-content:center}._1NMJC8-tzkpFLPSIqt-zaO{margin-top:calc(var(--headerHeight) * -1)}", ""]);

// exports
exports.locals = {
	"fullscreen": "_1zd9L-0DCb44zrq8fNFxmy",
	"first": "_1NMJC8-tzkpFLPSIqt-zaO _1zd9L-0DCb44zrq8fNFxmy"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&minimize&importLoaders=1!./~/postcss-loader!./src/components/fullscreen/styles.module.css
// module id = ./node_modules/css-loader/index.js?modules&minimize&importLoaders=1!./node_modules/postcss-loader/index.js!./src/components/fullscreen/styles.module.css
// module chunks = 5217438866945042000 13994203391546835000